export class MyprofileResponseModel {
    "email": String;
    "fullName": String;
    "mobile": Number;
    "siteLocation": String;
    "siteName": String;
    "userId": Number;
}